import { render, staticRenderFns } from "./traige.vue?vue&type=template&id=1ff8b055&"
import script from "./traige.vue?vue&type=script&lang=js&"
export * from "./traige.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports